import { render, staticRenderFns } from "./AssetField.vue?vue&type=template&id=f28e63b0&lang=pug&"
import script from "./AssetField.vue?vue&type=script&lang=js&"
export * from "./AssetField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f28e63b0')) {
      api.createRecord('f28e63b0', component.options)
    } else {
      api.reload('f28e63b0', component.options)
    }
    module.hot.accept("./AssetField.vue?vue&type=template&id=f28e63b0&lang=pug&", function () {
      api.rerender('f28e63b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/fields/AssetField.vue"
export default component.exports